import { createIconComponent } from '../../factory/create-icon-component';

export const AscendingIcon = createIconComponent(
  'AscendingIcon',
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3 6H11M3 12H11M3 18H13M15 8L18 5M18 5L21 8M18 5V18"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
